import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  CategoryValues,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../../convert-excel-to-impact-answers';

export type SectorTGS = (typeof SectorTGSValues)[number];
export const SectorTGSValues = [
  'Equipe',
  'Artistes',
  'Public',
  'Site',
] as const;

export function mapToSector(row: ImportedRow): Sector {
  const sectorValue = row['Sector'];
  const sectorTGS = validateValueInType<SectorTGS>(
    sectorValue,
    SectorTGSValues,
  );
  if (!sectorTGS) {
    return '';
  }
  switch (sectorTGS) {
    case 'Equipe':
      return 'TEAM';
    case 'Artistes':
      return 'ARTISTS';
    case 'Public':
      return 'PUBLIC';
    case 'Site':
      return 'SITE';
  }
}

export function mapToCategory(row: ImportedRow): Category {
  const categoryDescriptionValue = row['Fairly Category Description'];
  const category = validateValueInType<Category>(
    categoryDescriptionValue,
    CategoryValues,
  );
  return category;
}

export function mapToLabel(row: ImportedRow): string {
  const description = row['Description'];
  return description;
}
